// 受注配車入力一覧内の定数
export const 荷主Bindings = [
  "荷主コード",
  "荷主名",
  "荷主依頼番号",
  "表紙名",
  "荷主請求ID",
  "荷主略称1",
]
export const 積日Bindings = ["積日", "積時間"]
export const 卸日Bindings = ["卸日", "卸時間"]
export const 積地Bindings = [
  "積地積卸先コード",
  "積地社名",
  "積地都道府県",
  "積地市区町村",
]
export const 卸地Bindings = [
  "卸地積卸先コード",
  "卸地社名",
  "卸地都道府県",
  "卸地市区町村",
]

export const 品名Bindings = [
  "品コード",
  "品名",
  "積載品数量",
  "単位区分コード",
  "単位区分名称1",
]

export const 車輌Bindings = [
  "配車状態区分",
  "付替区分",
  "運行部所コード",
  "運行部所名",
  "傭車会社コード",
  "傭車会社名",
  "車番",
  "車種区分コード",
  "最大積載量",
  "トレーラ車番",
  "トレーラ車種区分コード",
  "トレーラ車種区分名称1",
  "乗務員名",
  "同乗者名",
  "同乗者乗務員名",
  "同乗場所区分コード",
  "同乗者場所区分ID",
  "車種区分名称1",
]

export const 請求Bindings = [
  "請求内訳コード",
  "請求区分コード",
  "単価",
  "請求車番",
  "履歴検索",
  "タリフ検索",
  "請求内訳名",
  "請求区分名称1",
  "請求運送料課税区分コード",
  "請求運送料",
  "請求付帯料課税区分コード",
  "請求付帯料",
  "請求高速料税込区分コード",
  "請求高速料税込区分名称1",
  "請求高速料",
  "請求合計",
  "計上基準日区分コード",
  "date請求計上日",
  "計上基準日区分名称",
  "請求備考",
  "高速料記号",
]

export const 乗務員売上Bindings = [
  "食事手当",
  "稼働手当車種掛率",
  "乗務員売上額",
  "乗務員付帯料",
  "付帯高速料",
  "稼働手当車種掛率区分名称1",
  "同乗者売上額",
]
export const 支払Bindings = [
  "支払運送料",
  "支払付帯料",
  "支払高速料",
  "支払合計",
  "date支払計上日",
  "支払備考",
]
